import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.png";
import { NavItems, SocialItems } from "../utils";
import { useLocation } from "react-router-dom";

export default function Navbar() {
  const activeLocation = useLocation().pathname;

  return (
    <div className="navbar">
      <div className="navbar__logo">
        <Link to="/">
          <img src={logo} alt="Vaibhav logo" />
        </Link>
        <p className="navbar__logo__text">Vaibhav</p>
      </div>

      <div className="navbar__items">
        <div className="navbar__items__main">
          {NavItems.map((item, index) => (
            <Link key={index} to={item.path}>
              <item.icon_name
                className="navbar__items__main__icons"
                style={
                  item.path === activeLocation
                    ? { color: "#ffd66b" }
                    : { color: "grey" }
                }
                fontSize="large"
              />
            </Link>
          ))}
        </div>

        <div className="navbar__items__social">
          {SocialItems.map((item, index) => (
            <a
              key={index}
              href={item.link}
              className={item.class}
              rel="noreferrer"
              target="_blank"
            >
              <item.icon_name style={item.style} fontSize="small" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
